import React from "react";
import SEO from '../../../services/SEO';
import { useEffect, useState } from "react";
import YoutubeEmbed from "../../../components/YoutubeEmbed";
import { Link } from "react-router-dom";
import Translator from "../../../components/Translator";
import { Divider, List, Typography, Card, Flex } from 'antd';
import { useTranslation } from "react-i18next";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const AdminDash = () => {

	window.scrollTo(0, 0);
	const axiosPrivate = useAxiosPrivate();
	const { t, i18n: { changeLanguage, language } } = useTranslation();

	const [dash, setDash] = useState({
		"qtd_usuarios": 0,
		"pag_assinaturas": 0
	});

	useEffect(() => {
		getInfoDash();
	}, []);

	const getInfoDash = async () => {

		try {
			const response = await axiosPrivate.post('/AdminDashboard');
			//console.log(response);
			if (response.status === 200) {

				if (response.data.length > 0) {
					let dash_info = JSON.parse(response.data[0].jsonInfo);
					setDash(dash_info[0])
					//console.log(dash_info[0]);
				} else {
					// setDatasource(()=>{
					// 	return [];
					// });
				}
			} else {
				// setDatasource(()=>{
				// 	return [];
				// });
			}
		} catch (err) {
			// setDatasource(()=>{
			// 	return [];
			// });
		}
	};

	return (
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t('administracao.dashboard')}</h2>
			<br />
			<hr />
			<br />
			<Flex>
				<Card
					title="Usuários"
					bordered={false}
					style={{
						width: 300,
					}}
				>
					<h1>{dash.qtd_usuarios}</h1>
				</Card>
				<Card
					title="Faturamento"
					bordered={false}
					style={{
						width: 300,
					}}
				>
					<h1>R$ {dash.pag_assinaturas.toFixed(2)}</h1>
				</Card>
			</Flex>
		</div>
	);
}


export default AdminDash;